/// <summary>
/// This object provides js functions for ... <br/>
/// <br/>
/// Author: ARF<br />
/// Date: 20.9.2022<br />
/// Copyright ©: EUDT GmbH 2022 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 20.9.2022                                               *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>
jQuery.widget("bluaul.SignalSelectionPopup", $.bluaul.vcMenuTemplate, {
   
   
    _create: function () {
        var me = this;
        try {
            me.element.html("");
            me.options.invoke.vcvid = 341;
            me.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));
            me._super();
          
        } catch (e) { me.writeError('_create', e); return false;}
        return true;
    },


    _initVariables: function () {
        var me = this;
        try {
            me._super();

            me.settings.defaultChart = "docu";
            me.settings.toggleView = false;
            me.settings.signalSelection = true;
            me.settings.showAllSignalsAtStart = true;
            me.settings.enableFilterForInvalidSignals = false;
            me.settings.hideSignalsWithNotAllowedSettings = false;
            me.settings.showArchiveRules = false;
            me.settings.enableMeta = false;


            me.settings.menu.top.showHeaders = true;
            me.settings.menu.top.showMenuAsDropdown = false;
            me.settings.menu.top.interval.enabled = false;
            me.settings.menu.top.datatype.enabled = false;
            me.settings.menu.top.charts.enabled = false;
            me.settings.menu.top.opt.enabled = true;
            me.settings.menu.main.button.enabled = true;
            me.settings.menu.main.button.showTakeBtnOnly = true;
            me.settings.menu.main.date.enabled = false;
            me.settings.menu.main.dateComparison.enabled = false;
            me.settings.menu.main.rampResolution.enabled = false;
            me.settings.menu.main.rampOptions.enabled = false;
            me.settings.menu.main.rampTempCharts.enabled = false;
            me.settings.menu.main.specificOptions.enabled = false;
            me.settings.menu.main.history.enabled = false;

            me.settings.menu.top.opt.enabled = false;
            me.settings.menu.top.opt.showTags = false;
            me.settings.menu.top.opt.showRules = false;
            me.settings.menu.top.opt.showInterventions = false;
            me.settings.menu.top.opt.showTickets = false;
            me.settings.menu.top.export.enabled = false;
            me.settings.menu.top.export.showFavorites = false;
            me.settings.menu.top.export.showShare = false;
           
            me.settings.selection.entries.button.enabled = true;
            me.settings.selection.entries.signals.showIcons = false;

          
        } catch (e) {
            me.writeError('_initVariables', e);
            return false;
        }
        return true;
    },


    _addAdditionalChartsToSettings: function () {
        var me = this;
        try {


            me._super();

            $.each(me.settings.charts, function () { this.enabled = false });
            var docu = me.settings.charts.filter(function (item) { return item.id == "docu" })[0];
            docu.enabled = true;
         

            $.each(me.settings.iconCharts, function () { this.enabled = false });
        } catch (e) {
            me.writeError('_addAdditionalChartsToSettings', e);
            return false;
        }
        return true;
    },


});

